var _defs, _g, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardImg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f2f60;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #1f2f60;\n        stroke-miterlimit: 10;\n        stroke-width: 32px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M570.54,676.06c-44.79,0-89.57.23-134.36-.14-12.22-.1-30.06,2.31-29.42-15.31.64-17.78,18.99-13.27,30.69-13.32,91.17-.42,182.34-.37,273.51.04,10.22.05,25.87-3.47,26.77,12.16,1.09,19.14-16.11,16.23-28.04,16.36-46.38.5-92.77.2-139.15.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.09,554.21c-47.96-.02-95.91.22-143.86-.24-9.04-.09-21.13-.21-21.51-13.09-.34-11.72,9.88-15.99,19.82-16.03,97.5-.37,195-.43,292.51-.14,9.93.03,19.9,4.38,18.87,16.51-1.08,12.71-12.78,12.75-21.95,12.82-47.95.39-95.91.18-143.86.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M615.29,435.89c-33.43.05-66.87.18-100.3-.03-10.45-.07-19.44-3.94-18.24-16.15.93-9.46,9.43-11.96,17.82-11.97,68.46-.13,136.91-.22,205.37.01,7.69.03,16.94.6,18.13,11,1.42,12.5-7.61,16.75-17.71,16.9-35.02.5-70.05.19-105.07.24Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 256.86,
    y: 175.48,
    width: 602.98,
    height: 789.52,
    rx: 25.12,
    ry: 25.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 859.85,
    y: 247.49,
    width: 143.15,
    height: 661.98,
    rx: 25.12,
    ry: 25.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 111,
    y: 244.73,
    width: 143.15,
    height: 661.98,
    rx: 25.12,
    ry: 25.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImg3);
export default __webpack_public_path__ + "static/media/cardImg3.59e9aa1daf25f48f1c32c30ae6b518f7.svg";
export { ForwardRef as ReactComponent };